import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlleCoreRest } from '../alle-core/alle-core-rest.service';
import { AlleCoreRestInterface } from '../alle-core/alle-core-rest.interface';
import { keys, keysUniversal } from 'src/app/resources/keys.resources';
import { Observable } from 'rxjs';
import { StoreServiceLibrary } from '../store/store.service';
import { GetJWTTokenService } from '../getJWTToken/get-jwttoken.service';
import { CryptoService } from '../crypto/crypto.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService implements AlleCoreRestInterface {
  // channelId = '2';

  /**
   * interface AlleCoreRestInterface
   */
  url = '';
  request: any;
  response: any;
  bearerToken;
  useBearer;
  keyServicesSsl: string;
  formData: any;
  fpjwt: any;

  constructor(
    private translate: TranslateService,
    private store: StoreServiceLibrary,
    private coreService: AlleCoreRest,
    private getJwt: GetJWTTokenService,
    private cryptoService: CryptoService
  ) { }

  getJwtAuth(useJwtToken) {
    const url = this.store.getJustOneUniversalPropertie(keysUniversal.AUTH_API_GET_JWTTOKEN_URL_V2);
    const un = this.store.getJustOneUniversalPropertie(keysUniversal.AUTH_API_GET_JWTTOKEN_UN);
    const pw = this.store.getJustOneUniversalPropertie(keysUniversal.AUTH_API_GET_JWTTOKEN_PW);
    if (useJwtToken) {
      return this.getJwt.getJwtGeneralCrypt(url, un, pw, keysUniversal.AUTH_API_GET_JWTTOKEN_URL_V2);
    } else {
      return new Observable((observer) => {
        observer.next(null);
        observer.complete();
      });
    }
  }

  registerWebV2(request) {
    this.url = this.store.getJustOneUniversalPropertie(keysUniversal.REGISTER_WEB_V2);
    this.request = request;
    let content = this.cryptoService.generateRequest(request);
    const encryptedRequest: any = {
      content
    }
    this.request = encryptedRequest;

    return new Observable((observer) => {
      this.coreService.callService(this).subscribe(
        (resp: any) => {
          let respEncrypt = this.cryptoService.convertResponse(resp);

          try {
            resp = JSON.parse(respEncrypt);
          } catch (error) {
            resp = null;
          }

          observer.next(resp);
          observer.complete();
        },
        err => {
          observer.error(err)
          observer.complete();
        });
    });
  }

  registerWeb(request) {
    this.url = this.store.getJustOneUniversalPropertie(keysUniversal.REGISTER_WEB);
    this.request = request;

    return new Observable((observer) => {
      this.coreService.callService(this).subscribe(
        (resp: any) => {
          observer.next(resp);
          observer.complete();
        },
        err => {
          observer.error(err)
          observer.complete();
        });
    });
  }

  getJwtWithCall(useJwtToken, body: AlleCoreRestInterface) {
    return new Observable((observer) => {
      this.getJwtAuth(useJwtToken).subscribe((jwtToken: string) => {
        this.store.setItemInStorage(keys.key_jwt_auth_general, jwtToken);
        // this.bearerToken = jwtToken;
        body.bearerToken = jwtToken;
        this.coreService.callService(body).subscribe(
          (resp: any) => {
            observer.next(resp);
            observer.complete();
          }, (err) => observer.error(err));
      }, err => observer.error(err));
    });
  }
}
